import BrowserHistory from './components/BrowserHistory/index'

import './App.css'

const App = () => <BrowserHistory />

export default App
